import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import CommonHeader from '@/components/CommonHeader.vue';
import Thumbnail from '@/components/Thumbnail.vue';
import BeeInput from '@/components/BeeInput.vue';
import AjaxButton from '@/components/AjaxButton.vue';
import CounterButton from '@/components/CounterButton.vue';
import Modal from '@/components/Modal.vue';
import { StatusDelivery } from '../models/Order';
import OrderService from '@/services/OrderService';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import { MainView, TypeOrder } from '@/store/state';
import axios from 'axios';
import SpinnerHolder from '@/components/SpinnerHolder.vue';
let Command = class Command extends Vue {
    constructor() {
        super(...arguments);
        this.menuName = this.$store.state.menu.name;
        this.modalForm = false;
        this.modalFormDelivery = false;
        this.validatedCaptcha = true;
        this.order = this.$store.state.order;
        this.thumbnailBorder = `border: 1px ${this.$store.getters.colors.backgroundColor} solid;`;
        this.goodEnding = false;
        this.loading = false;
        this.ajaxError = false;
        this.typeOrder = this.$store.state.typeOrder;
        this.user = null;
        this.acceptTerms = false;
        this.formData = {
            name: '',
            place: '',
            phone: '',
            email: '',
            terms: false,
        };
        this.formErrors = {
            name: false,
            place: false,
        };
        this.formErrorDelivery = {
            name: false,
            phone: false,
            email: false,
            terms: false,
            phoneRepeat: false,
        };
    }
    get qrCodeContent() {
        if (this.order) {
            let textOrder = `#${this.order.number} \n`;
            textOrder += `${this.order.name} \n`;
            if (this.typeOrder == TypeOrder.DELIVERY || this.typeOrder == TypeOrder.COLLECT) {
                textOrder += `${this.order.phone} \n`;
                textOrder += `${this.order.email} \n`;
            }
            else {
                textOrder += `${this.order.location} \n`;
            }
            for (const item of this.order.items) {
                textOrder += `${item.name} X ${item.quantity} $ ${item.price} \n`;
                const plus = item.ingredients.filter((i) => i.selected);
                if (plus.length)
                    textOrder += this.reduceIngredients(plus, this.$t('with').toString()) + '\n';
                const minus = item.ingredients.filter((i) => !i.selected);
                if (minus.length)
                    textOrder += this.reduceIngredients(plus, this.$t('without').toString()) + '\n';
                textOrder += '\n';
            }
            textOrder += `TOTAL: $${this.order.total} \n`;
            return textOrder;
        }
        return 'orden vacia';
    }
    get orderSent() {
        if (this.order && this.order.sent)
            return true;
        return false;
    }
    showFormOrContinueProcess() {
        const user = this.$store.state.user;
        if (this.typeOrder == TypeOrder.DELIVERY || this.typeOrder == TypeOrder.COLLECT) {
            if (!user) {
                this.$router.push('/login');
            }
            else if (!this.checkDataUser()) {
                this.$router.push('/personalinfoedit');
            }
            else if (user && this.checkDataUser()) {
                if (this.$store.state.order.statusDelivery == StatusDelivery.ORDER) {
                    if (this.typeOrder == TypeOrder.LOCAL && this.order) {
                        this.modalForm = true;
                    }
                    else if (this.typeOrder == TypeOrder.DELIVERY ||
                        (this.typeOrder == TypeOrder.COLLECT && this.order)) {
                        this.$router.push('/summary');
                        // this.modalFormDelivery = true
                    }
                }
                else if (this.$store.state.order.statusDelivery == StatusDelivery.FINISHED) {
                    this.modalForm = true;
                }
                else if (this.$store.state.order.statusDelivery == StatusDelivery.SUMMARY) {
                    this.$router.push('/summary');
                }
            }
        }
    }
    get readableId() {
        if (this.order?.number) {
            return '#' + this.order.number;
        }
        return '';
    }
    async botValidation() {
        let token = '';
        if (process.env.NODE_ENV == 'production') {
            await this.$recaptchaLoaded();
            token = await this.$recaptcha('sendOrder');
            try {
                const resp = await axios.post(`${process.env.VUE_APP_RECAPTCHA_VERIFIER}/api/v1/verify`, {
                    token: token,
                });
                if (resp.data && resp.data.score < 0.5) {
                    this.validatedCaptcha = false;
                    this.ajaxError = true;
                    return;
                }
            }
            catch (err) {
                console.log(err);
            }
        }
        await this.sendForm(token);
    }
    async sendForm(token) {
        if (!this.order)
            return;
        if (!this.validForm())
            return;
        this.loading = true;
        if (this.user)
            this.order.userId = this.user.id;
        this.order.name = this.formData.name;
        this.order.number = OrderService.generateReadableId();
        this.order.status = 'PENDING';
        if (this.typeOrder == TypeOrder.DELIVERY || this.typeOrder == TypeOrder.COLLECT) {
            this.order.email = this.formData.email;
            this.order.phone = this.formData.phone;
            if (this.typeOrder == TypeOrder.DELIVERY) {
                this.order.type = TypeOrder.DELIVERY;
                this.order.statusDelivery = StatusDelivery.SUMMARY;
            }
            else if (this.typeOrder == TypeOrder.COLLECT) {
                this.order.type = TypeOrder.COLLECT;
            }
        }
        else if (this.typeOrder == TypeOrder.LOCAL) {
            this.order.location = this.formData.place;
            this.order.type = TypeOrder.LOCAL;
        }
        this.$analytics.logEvent('begin_checkout', {
            value: this.order.subtotal + this.order.deliveryCost,
            currency: this.order.currency,
            items: this.order.items.map((item) => ({
                item_id: item.id,
                item_name: item.name,
                quantity: item.quantity,
                price: Number(item.price),
                item_category: item.category,
                item_category2: item.subcategory,
                item_brand: this.$store.state.menu.name,
                affiliation: this.$store.state.typeOrder,
            })),
        });
        if (this.typeOrder != TypeOrder.DELIVERY) {
            if (this.order)
                this.order.total = this.order.subtotal + this.order.deliveryCost;
            const result = await OrderService.sendOrder(this.order, token, this.order.type);
            if (result) {
                this.$store.commit('setOrder', this.order);
            }
            else {
                this.ajaxError = true;
            }
        }
        else {
            this.loading = false;
            this.$router.push('/summary');
        }
        this.loading = false;
    }
    validForm() {
        if (this.typeOrder == TypeOrder.LOCAL) {
            this.formErrors = { name: false, place: false };
            if (!this.formData.name)
                this.formErrors.name = true;
            if (!this.formData.place)
                this.formErrors.place = true;
            for (const error of Object.values(this.formErrors)) {
                if (error == true)
                    return false;
            }
        }
        else {
            this.formErrorDelivery = { name: false, phone: false, email: false, terms: false, phoneRepeat: false };
            if (!this.formData.name)
                this.formErrorDelivery.name = true;
            if (!this.formData.phone || !/^[0-9]{10}$/.test(this.formData.phone))
                this.formErrorDelivery.phone = true;
            if (this.checkDigitRepeated(this.formData.phone, 5))
                this.formErrorDelivery.phoneRepeat = true;
            if (!this.formData.email || !/^\S+@.+\.\S+$/.test(this.formData.email))
                this.formErrorDelivery.email = true;
            if (!this.formData.terms)
                this.formErrorDelivery.terms = true;
            for (const error of Object.values(this.formErrorDelivery)) {
                if (error == true)
                    return false;
            }
        }
        return true;
    }
    checkDigitRepeated(input, repeat) {
        const regex = new RegExp('(\\d)\\1{' + repeat + '}', 'g');
        return !!input.match(regex);
    }
    hideForm() {
        this.modalForm = false;
    }
    hideFormDelivery() {
        this.modalFormDelivery = false;
    }
    reduceIngredients(ingredients, start) {
        let text = '';
        ingredients.forEach((ing, index) => {
            if (ing.selected) {
                const aux = start + ' ' + ing.localizedNames;
                text += `${index == 0 ? aux : ', ' + aux}: `;
                const lastIndexSelected = ing.extraIngredients.length -
                    [...ing.extraIngredients].reverse().findIndex((ext) => ext.selected == true);
                ing.extraIngredients.forEach((extra, index) => {
                    if (extra.selected) {
                        text += `${index + 1 == lastIndexSelected ? extra.localizedNames : extra.localizedNames + ', '}`;
                    }
                });
            }
        });
        return text;
    }
    updateItemQuantity(index, quantity) {
        this.$store.dispatch('updateItemQuantity', { index, quantity });
    }
    async created() {
        await this.$store.dispatch('setMainView', MainView.COMMAND);
        this.user = this.$store.state.user;
        if (this.user) {
            this.formData.name = this.user.name;
            this.formData.email = this.user.email;
            this.formData.phone = this.user.phone;
        }
        if (this.order) {
            this.$analytics.logEvent('view_cart', {
                value: this.order.subtotal + this.order.deliveryCost,
                currency: this.order.currency,
                items: this.order.items.map((item) => ({
                    item_id: item.id,
                    item_name: item.name,
                    quantity: item.quantity,
                    price: Number(item.price),
                    item_category: item.category,
                    item_category2: item.subcategory,
                    item_brand: this.$store.state.menu.name,
                    affiliation: this.$store.state.typeOrder,
                })),
            });
        }
    }
    get newUser() {
        return this.$store.state.user;
    }
    onNewUserChanged(newUser) {
        if (newUser) {
            this.formData.name = newUser.name;
            this.formData.email = newUser.email;
            this.formData.phone = newUser.phone;
        }
    }
    checkDataUser() {
        const user = this.$store.state.user;
        if (user) {
            for (const value in user) {
                if (user[value] == undefined || user[value] == '') {
                    return false;
                }
            }
        }
        else {
            return false;
        }
        return true;
    }
};
__decorate([
    Watch('newUser')
], Command.prototype, "onNewUserChanged", null);
Command = __decorate([
    Component({
        components: {
            CommonHeader,
            Thumbnail,
            CounterButton,
            BeeInput,
            Modal,
            AjaxButton,
            VueQrcode,
            SpinnerHolder,
        },
    })
], Command);
export default Command;
